import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { ResponseSuccessProcess } from '../../../../shared/interfaces/successProcess.interface';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class SuccessProcessHandler {
  constructor(
    private http: HttpClient
  ) { }

  getBullets(): Observable<ResponseSuccessProcess> {
    const endpoint = environment.staticScripts.staticAssets + 'json/success-process.json';
    return this.http.get<ResponseSuccessProcess>(endpoint);
  }
}
